import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {QueryClient,QueryClientProvider} from '@tanstack/react-query';
import {AuthProvider} from './auth';
import {App} from './App';
import {WebBuildUpdateGuard} from './telephony';
import {ThemeProvider} from './theme';
import {loadRuntimeConfig, resolveUiShellVersion, UI_SHELL_STORAGE_KEY} from './app/runtime-config';
import './design/tokens.css';
import './design/themes.css';
import './styles.css';
import './design/base.css';
import './components/ui/ui.css';
import './layout/shell.css';
import './features/contact-center/contact-center-v3.css';
import './features/tickets/ticket-table.css';
import './features/tickets/ticket-kanban.css';
import './features/tickets/ticket-detail.css';
import './features/directories/contact-detail-workspace.css';
import './features/directories/company-detail-workspace.css';
import './features/templates/template-workspace.css';
import './features/planned-works/planned-workspace.css';
import './features/billing/billing-workspace.css';
import './features/dashboard/dashboard-neumorphic.css';

const queryClient=new QueryClient({defaultOptions:{queries:{retry:1,staleTime:15000}}});

async function bootstrap() {
  const runtimeConfig = await loadRuntimeConfig();
  let stored: string | null = null;
  try { stored = window.localStorage.getItem(UI_SHELL_STORAGE_KEY); } catch { /* storage can be unavailable */ }
  const shell = resolveUiShellVersion({ runtimeEnabled: runtimeConfig.uiShellV2, search: window.location.search, stored });
  if (shell.persist) {
    try { window.localStorage.setItem(UI_SHELL_STORAGE_KEY, shell.persist); } catch { /* storage can be unavailable */ }
  }

  createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider><BrowserRouter><WebBuildUpdateGuard><AuthProvider><App uiShellVersion={shell.version}/></AuthProvider></WebBuildUpdateGuard></BrowserRouter></ThemeProvider>
      </QueryClientProvider>
    </React.StrictMode>,
  );
}

void bootstrap();
